export default "__VITE_ASSET__Doqygdw8__"